class ReviewsWrapper extends HTMLElement {
    #boundMutationCallback = this.mutationCallback.bind(this);
    #observer;

    static MINIMUM_RECOMMENDATION_PERCENTAGE = 75;

    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = '<slot></slot>';
    }

    connectedCallback() {
        this.render();
    }


    mutationCallback(mutationsList, observer) {
        this.addAriaAttributesRating();
        this.removeLowRecommendationPercentageWidget();
    }

    removeLowRecommendationPercentageWidget() {
        const recommendationPercentageWidget = this.getElementsByClassName('stamped-summary-recommend')[0];
        if(!recommendationPercentageWidget) {
            console.warn('Stamped recommendation percentage widget not found');
            return;
        }

        const recommendationPercentageContainer = recommendationPercentageWidget.getElementsByClassName('stamped-summary-recommend-percent')[0];
        if(!recommendationPercentageContainer) {
            console.warn('Stamped recommendation percentage container not found');
            return;
        }

        const recommendationPercentage = parseInt(recommendationPercentageContainer.innerText);
        if (recommendationPercentage < ReviewsWrapper.MINIMUM_RECOMMENDATION_PERCENTAGE) {
            recommendationPercentageWidget.remove();
        }
    }

    addAriaAttributesRating() {
        const summaryStarRating = this.getElementsByClassName('stamped-summary-starrating')[0];
        if (summaryStarRating) {
            summaryStarRating.setAttribute('role', 'img');
        }
        // based on settings value, this is the reviews widget. Render script to 
        // fix missing aria attributes.
        const stampedReviewRatings = Array.from(this.getElementsByClassName('stamped-review-header-starratings'));
        if (stampedReviewRatings.length === 0) {
            console.warn('Stamped review ratings not found');
        } else {
            for (let rating of stampedReviewRatings) {
                rating.setAttribute('role', 'img');
                const ratingStars = Array.from(rating.getElementsByClassName('stamped-fa-star'));
                for (let star of ratingStars) {
                    star.setAttribute('aria-hidden', 'true');
                }
            }
        }
    }

    render() {
        const blockElement = this.querySelector('.shopify-block');

        // this code only affects stamped blocks
        if (!blockElement.id.includes('stamped')){
            return;
        }

        // mutation observer for app container, run on changes
        this.#observer = new MutationObserver(this.#boundMutationCallback);
        this.#observer.observe(this, { childList: true, characterData: true, subtree: true });

        // Run once immediately in case widget content is already present.
        this.addAriaAttributesRating();
        this.removeLowRecommendationPercentageWidget();
    }

    disconnectedCallback() {
        if (this.#observer) {
            this.#observer.disconnect();
        }
    }
}

customElements.define('reviews-wrapper', ReviewsWrapper);
